import { render, staticRenderFns } from "./widget1.vue?vue&type=template&id=f82a7d62&scoped=true"
import script from "./widget1.vue?vue&type=script&lang=js"
export * from "./widget1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82a7d62",
  null
  
)

export default component.exports